import { X } from "react-feather";
import { Href } from "../../../../Constants/Constants";
import { CommonHeadingType } from "../../../../Types/MessengerType";
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks";
import { smallSideBarToggle } from "../../../../ReduxToolkit/Reducers/Messenger/AppSidebar";

const CommonHeading: React.FC<CommonHeadingType> = ({ title, sunTitle }) => {
  const dispatch = useAppDispatch();

  return (
    <div className="template-title">
      <div className="d-flex">
        <div>
          <h3>{title}</h3>
          <h5>{sunTitle}</h5>
        </div>
        <div className="flex-grow-1">
          <a className="icon-btn btn-sm btn-outline-light close-apps" href={Href} onClick={() => dispatch(smallSideBarToggle())}>
            <X />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CommonHeading;
